module.exports = "/fonts/ProductSans-Light.woff?cabe32b8f11068b344046a9ef7d6ebf3";